import {
  lineSizes,
  pinSizes,
} from 'features/Procedure/procedure-model/draw-customizer/customizer.constants'

const FREE_LINE_PRESETS = [lineSizes[0], lineSizes[1], lineSizes[2], lineSizes[3]]

const PIN_SIZE_PRESETS = [pinSizes[0], pinSizes[1], pinSizes[2], pinSizes[3]]

export const getXStrokeWidthForSize = (xSize: number): number => {
  let bestIdx = 0
  let bestDiff = Math.abs(PIN_SIZE_PRESETS[0] - xSize)
  for (let i = 1; i < PIN_SIZE_PRESETS.length; i++) {
    const diff = Math.abs(PIN_SIZE_PRESETS[i] - xSize)
    if (diff < bestDiff) {
      bestDiff = diff
      bestIdx = i
    }
  }
  return lineSizes[bestIdx]
}

export const normalizeStrokeWidthToFreeLinePreset = (width: number): number => {
  let best = FREE_LINE_PRESETS[0]
  let bestDiff = Math.abs(width - best)
  for (let i = 1; i < FREE_LINE_PRESETS.length; i++) {
    const v = FREE_LINE_PRESETS[i]
    const d = Math.abs(width - v)
    if (d < bestDiff) {
      bestDiff = d
      best = v
    }
  }
  return best
}
